import { type ReactNode } from 'react';
import {
  NO_CODE_CREATE_FORM,
  NO_CODE_UPDATE_FORM,
  useFeatureFlag,
} from '@shared/util/featureFlags';
import { ResponsiveFormContext } from './context';

export function ResponsiveFormProvider({ children }: { children: ReactNode }) {
  const noCodeCreate = useFeatureFlag(NO_CODE_CREATE_FORM);
  const noCodeUpdate = useFeatureFlag(NO_CODE_UPDATE_FORM);
  const isResponsiveForms = noCodeCreate && noCodeUpdate;
  return (
    <ResponsiveFormContext.Provider value={isResponsiveForms}>
      {children}
    </ResponsiveFormContext.Provider>
  );
}
